import * as React from 'react';
import { Modal } from 'react-bootstrap';

import { BackgroundPref, FrequencyTypes } from '../../../common/models/index';
import { BackgroundPicker } from './BackgroundPicker';
import { BackgroundPainter } from './BackgroundPainter';
import { ErrorLogger } from '../error/ErrorLogger';

interface PickerModalProps {
  show: boolean;
  bgPref?: BackgroundPref;
  backgroundService: BackgroundPainter;
  errorLogger: ErrorLogger;
  onHide(): void;
  onChange(bgPref: BackgroundPref): void;
  onSave(bgPref: BackgroundPref): Promise<void>;
}
interface PickerModalState {
  loading: boolean;
}

const DEFAULT_PREF = {
  backgroundRotation: FrequencyTypes.QUARTERLY
} as BackgroundPref;

export class BackgroundPickerModal extends React.Component<PickerModalProps, PickerModalState> {
  change = (bgPref: BackgroundPref) => this.props.onChange(bgPref);

  save = async () => {
    if (this.props.bgPref) {
      try {
        this.setState({ loading: true });

        await this.props.onSave(this.props.bgPref);
      } catch (err) {
        await this.props.errorLogger.log(err);
      }

      this.setState({ loading: false });
    }
  };

  constructor(props: PickerModalProps) {
    super(props);

    this.state = { loading: false };
  }

  render() {
    const photos = this.props.backgroundService.photos;
    const nextPhoto = this.props.backgroundService.nextPhoto.bind(this.props.backgroundService);

    return (
      <Modal onHide={this.props.onHide} show={this.props.show} bsSize="sm">
        <Modal.Header closeButton={true} closeLabel="&times;">
          <Modal.Title>Background Picker</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BackgroundPicker
            bgPref={this.props.bgPref || DEFAULT_PREF}
            photos={photos}
            nextPhoto={nextPhoto}
            onChange={this.change}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-default" onClick={this.props.onHide}>Cancel</button>
          <button className="btn btn-primary" onClick={this.save}>
            {this.state.loading ? ( <span><i className="fa fa-spinner fa-spin"/></span> ) : 'Save'}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/BackgroundPickerModal.tsx